import baseApi from "@/api/baseApi";

export default {
  async fetchReportData(orderSetId) {
    return baseApi.get(`api-ear-marks/api/order-elba/v1/elba/${orderSetId}`);
  }
}
